import { LabelValueForText } from "components/ui/atoms/LabelValue";
import dayjs from "dayjs";
import { getCommons } from "./fieldConverterHelpers";
import { LinkCell } from "./linkFieldView";

export const DateFieldView = ({ field, value }) => {
  const cleanedDefaultValue = value ? dayjs(value) : null;

  return (
    <LabelValueForText
      label={field.label}
      sx={{ display: field.hidden ? "none" : "inherit" }}
      value={cleanedDefaultValue?.format("DD/MM/YYYY")}
      isMissing={!cleanedDefaultValue}
    />
  );
};

export const dateFieldConverter = ({ field, model }) => {
  return {
    ...getCommons({ field, model }),
    type: "date",
    valueGetter: (value) => {
      if (!value) return {};
      return new Date(value).toISOString();
    },
    valueFormatter: (value) => {
      if (!value) return "";
      return new Date(value).toLocaleDateString();
    },
    renderCell: field.link ? LinkCell : undefined,
  };
};
